import React, { useState } from 'react';
import { useUser } from '@clerk/clerk-react';
import Characters from '../components/Characters/Characters.js';
import '../styles/CharactersPage.css';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button.jsx';
import { useSubscription } from '../contexts/SubscriptionContext.js';

function CharactersPage({ characters, addCharacter, updateCharacter, deleteCharacter, isLoading }) {
  const { user } = useUser();
  const { tier: userTier } = useSubscription();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const isEmpty = !isLoading && (!characters || characters.length === 0);

  return (
    <div className="characters-page p-3 sm:p-4 md:p-6 bg-gradient-to-br from-indigo-100 to-purple-100 dark:from-indigo-900/50 dark:to-purple-900/50 rounded-lg shadow-md min-h-screen">
      <h1 className="text-3xl font-bold mb-4 sm:mb-6 text-center text-indigo-800 dark:text-indigo-200">Characters</h1>

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Loading characters...</Typography>
        </Box>
      ) : isEmpty ? (
        <div className="flex flex-col items-center justify-center text-center py-12 px-4 sm:py-16 max-w-xl mx-auto">
          <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mb-6">
            <Sparkles className="w-10 h-10 text-primary" />
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-indigo-900 dark:text-indigo-100 mb-3">
            Create your first character
          </h2>
          <p className="text-base text-indigo-700/80 dark:text-indigo-200/80 mb-8 leading-relaxed">
            Every magical bedtime story starts with a character your child loves. Add their
            name, traits, and dreams — we'll bring them to life across every story.
          </p>
          <Button
            size="lg"
            onClick={() => setIsDialogOpen(true)}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            <Sparkles className="w-4 h-4 mr-2" />
            Add your first character
          </Button>
        </div>
      ) : (
        <Characters
          characters={characters}
          addCharacter={addCharacter}
          updateCharacter={updateCharacter}
          deleteCharacter={deleteCharacter}
          userTier={userTier}
          user={user}
          isDialogOpen={isDialogOpen}
          setIsDialogOpen={setIsDialogOpen}
        />
      )}

      {/* Render Characters dialog-only when empty so the add dialog still works */}
      {isEmpty && !isLoading && (
        <Characters
          characters={characters}
          addCharacter={addCharacter}
          updateCharacter={updateCharacter}
          deleteCharacter={deleteCharacter}
          userTier={userTier}
          user={user}
          isDialogOpen={isDialogOpen}
          setIsDialogOpen={setIsDialogOpen}
        />
      )}
    </div>
  );
}

export default CharactersPage;
